<div class="layout-main">
  <div class="container-fluid">
    <div class="symbols-title-row">
      <h3 class="mb-0">
        <b>Raw: products information</b>
      </h3>
      <div class="symbols-title-meta">
        <span *ngIf="qrdSymbolsInfo?.updatedAt">Updated
          on: {{ qrdSymbolsInfo?.updatedAt | date: 'yyyy-MM-dd H:mm:ss' }}</span>
      </div>
    </div>
    <div *ngIf="noData || (!thereIsDataToDisplay(productList) && !loading)">
      <p class="symbols-empty-note">No data found</p>
    </div>
    <div *ngIf="thereIsDataToDisplay(productList) && !loading" class="symbols-market-table">
      <p-table [columns]="cols" [rowHover]="true" [tableStyle]="{'table-layout':'auto'}"
               [value]="productList" id="qrd-product-information">
        <ng-template pTemplate="caption">
          Products
          <span class="symbols-table-count">{{ productList.length }} products</span>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th *ngFor="let col of cols">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template [ngForOf]="productList" let-product ngFor pTemplate="body">
          <tr *ngFor="let pop of createPopListForProduct(product); first as firstPop">
            <td *ngIf="firstPop" [attr.rowspan]="createPopListForProduct(product).length"
                style="vertical-align: top">{{ product.name }}
            </td>
            <td>{{ pop }}</td>
            <td class="symbols-check-col">
              <i *ngIf="getConnectivityByProduct(product.id)[pop]['QRDL1']" class="fa fa-check symbols-check"></i>
            </td>
            <td class="symbols-check-col">
              <i *ngIf="getConnectivityByProduct(product.id)[pop]['QRDL3']" class="fa fa-check symbols-check"></i>
            </td>
            <td class="symbols-check-col">
              <i *ngIf="getConnectivityByProduct(product.id)[pop]['QPDL3']" class="fa fa-check symbols-check"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
